import React, { useState, useRef } from "react";
import Button from "../Button";
import Modal from "../../Modal";
import Form from "../Form";
import Input from ".";

function EditableInput({ value, type, label = "", noNumbers, allowSpecialChars, required = false, onChange = () => {}, onUpdate = () => {}, className = "", loading }) {
	const [Edit, setEdit] = useState();
	const [Value, setValue] = useState(value);

	const INPUT = useRef();

	const onSubmit = () => {
		const val = INPUT.current.value;
		onUpdate(val);
		setEdit();
	};

	return (
		<>
			<Button onClick={() => setEdit(true)} variant="outlined" className={`!inline-block align-middle btn-xs mr-2 ${className}`}>
				Edit
			</Button>
			<Modal open={Edit} onClose={() => setEdit()}>
				<Form onSubmit={onSubmit}>
					<div className="flex p-3 gap-x-2">
						<Input noNumbers={noNumbers} allowSpecialChars={allowSpecialChars} required={required} ref={INPUT} placeholder={label} type={type} value={Value} onChange={(val) => setValue(val)} className="flex-grow" />
						<Button loading={loading} type="submit">
							Update
						</Button>
					</div>
				</Form>
			</Modal>
		</>
	);
}

export default EditableInput;
